import styled from 'styled-components'
import Navigation from 'components/navigation'
import Footer from 'common/footer'
import Wrapper from 'common/wrapper'
import ScholarshipRules from 'components/scholarships/rules'
import ScholarshipSteps from 'components/scholarships/steps'
import { Typography } from 'common/typography'
import FinalReward from 'components/scholarships/final-reward'
import { PinkGradient } from 'home/platform'

const ScholarshipsHeader = styled.section`
  background: linear-gradient(180deg,#082054 1.47%,rgba(4,0,30,0.9) 100%);
  padding-block-start: 112px;
  padding-block-end: 40px;
  text-align: center;
  h1 {
    ${PinkGradient}
    margin-block-end: 24px;
  }
  @media(min-width: 1024px) {
    h1 {
      margin-block-end: 48px;
    }
  }
  @media (min-width: 768px) {
    padding-block-end: 80px;
  }
  @media (min-width: 1024px) {
    padding-block-start: 80px;
  }
`

function Scholarships() {
  return (
    <>
      <Navigation maxWidth="1336px" />
      <ScholarshipsHeader aria-labelledby="steps">
        <Wrapper maxWidth="650">
          <Typography as="h1" id="steps" small="headline4" large="headline1">
            Pasos a seguir para ganarte una beca
          </Typography>
          <p>La constancia y dedicación son valores que admiramos en cada estudiante, por eso queremos incentivar esa actitud premiándote con una beca por estudiar.</p>
        </Wrapper>
      </ScholarshipsHeader>
      <ScholarshipSteps />
      <FinalReward />
      <ScholarshipRules />
      <Footer />
    </>
  )
}

export default Scholarships
